import { InfoCircle } from 'react-bootstrap-icons';
import { useParams } from 'react-router-dom';

import { Typography } from 'antd';

import { useLog } from '@/hooks/useLog';
import { commentsApi, useGetConfigCommentsQuery, useSaveCommentMutation } from '@/services/comments';
import { useGetCourseQuery } from '@/services/course';
import { lessonsApi } from '@/services/lesson';
import styled, { css, StyledProp } from '@/styled';

import CommentForm from './Form';
import ListComment from './ListComment';

const { Text } = Typography;

const Comments = ({ className }: StyledProp) => {
  const { id } = useParams();
  const [comment, { isLoading }] = useSaveCommentMutation();
  const { hash } = useParams();
  const {
    data: { producer }
  } = useGetCourseQuery(hash);
  const { data: configComments } = useGetConfigCommentsQuery({ lessonId: id, producerId: producer?.id });
  const { data: lesson } = lessonsApi.endpoints.getLessons.useQueryState(id);
  const [reloadList] = commentsApi.endpoints.getComments.useLazyQuerySubscription();
  const { activity } = useLog();

  const submitComment = (values: { message: string }) => {
    return comment({ lessonId: id, comment: values.message }).then(() => {
      reloadList({ lessonId: id, params: { page: 1, ownComments: true } });
      activity({
        context: 'commented',
        additionalData: {
          message: `Comentou na aula ${lesson.title}`,
          course_hash: lesson.hash_course,
          lesson_id: lesson.id
        }
      });
    });
  };

  return (
    <div className={className}>
      {configComments?.timeToRespond && (
        <div className='time-to-respond'>
          <InfoCircle />
          <Text className='time-to-respond-text'>{configComments?.timeToRespondMessage}</Text>
        </div>
      )}
      <CommentForm onFinish={submitComment} isLoading={isLoading} />
      <ListComment />
    </div>
  );
};

export default styled(Comments)(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;

    .time-to-respond {
      display: flex;
      align-items: center;
      gap: ${theme.space.pxToRem(8)};
      margin-bottom: ${theme.space.pxToRem(16)};
      color: ${theme.palette.gray[6]};
    }

    .time-to-respond-text {
      font-size: ${theme.space.pxToRem(12)};
      color: ${theme.palette.gray[6]};
    }
  `
);
